export default "__VITE_ASSET__CRUkzHek__"